var render = function render(){var _vm=this,_c=_vm._self._c;return _c('catalog-data',{attrs:{"table-cfg":_vm.tableCfg,"ascending":_vm.tableCfg.ascending,"isAllSolutions":"table-cfg.isAllSolutions"}})
}
var staticRenderFns = []

export { render, staticRenderFns }